import { defineComponent as _defineComponent } from 'vue'
import { reactive, toRefs } from "vue";

interface State {
	/**
	 * モーダル開閉状態。
	 */
	isOpen: boolean;
}
// reactiveな変数宣言

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

/**
 * モーダル表示用コンポーネント。
 * 本プロジェクト内部でモーダル要素を利用する場合は、原則このコンポーネントを使用する事。
 */

const state = reactive<State>({
	isOpen: false,
});
const { isOpen } = toRefs(state);

/**
 * モーダルを開く処理。
 * 親コンポーネントから`ref`を使い、当メソッドを呼び出してモーダルを開くこと。
 */
const openModal = (): void => {
	state.isOpen = true;
};

// モーダルを閉じる処理
const closeModal = (): void => {
	state.isOpen = false;
};

expose({
	openModal,
});

const __returned__ = { state, isOpen, openModal, closeModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})